import CommonService from './common';
import { WEB_SSO } from '../../../utils/urls';
import { encryptParams } from '../../../utils/index';

export default class QuickAuthService extends CommonService {
  /**
   * [get mobile verification code] out-of-date
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCode = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCode({
      ...rest,
      type: 22,
      ...extra_params,
    });
  };

  /**
   * [get mobile verification code V2]
   * @param {string} mobile the mobile used to login
   * @return {Promise} send result
   */
  public sendMobileCodeV2 = (params: {
    mobile: string;
    extra_params?: object;
  }): Promise<any> => {
    const { extra_params = {}, ...rest } = params;
    return this.baseSendMobileCodeV2({
      ...rest,
      type: 22,
      ...extra_params,
    });
  };
  /**
   * [quick auth by mobile]
   * @param {string} service redirect url after login success
   * @param {string} code mobile verify code
   */
  public quickAuth = (params: {
    service: string;
    code: string;
    extra_params?: object;
  }): Promise<any> => {
    let { code, extra_params = {}, ...rest } = params;
    const data = encryptParams({ code, ...rest, ...extra_params }, ['code']);
    return this.request({
      url: WEB_SSO.QUICK_AUTH,
      method: 'POST',
      data,
    });
  };
}
